import {TOGGLE} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

export default attribute({
  type: TOGGLE,
  attribute: 'app_reservations_allowed',
  label: {
    default: 'App Reservations Allowed',
    short: 'App Reservations Allowed',
  },
});
